import { useQuery } from '@tanstack/react-query'
import {
  listCalendarLookup,
  type ListCalendarLookupParams,
} from '@/api/calendarLookup'

export function useCalendarLookup(params: ListCalendarLookupParams = {}) {
  return useQuery({
    queryKey: ['calendar-lookup', params],
    queryFn: () => listCalendarLookup(params),
  })
}
